import { type StateCode, states } from '@fv/models'

export const statesByCode: Record<StateCode, string> = Object.fromEntries(
  states.map(s => [s.abbreviation, s.name]),
)
